import request from '@/utils/request'

// 获取关于我们配置文案
export function getAboutConfigs(query) {
  return request({
    url: '/cms/about/config/public/list',
    method: 'get',
    params: query
  })
}

// 获取企业精神列表
export function getAboutSpirits() {
  return request({
    url: '/cms/about/spirit/public/list',
    method: 'get'
  })
}

// 获取资质荣誉列表
export function getAboutHonors() {
  return request({
    url: '/cms/about/honor/public/list',
    method: 'get'
  })
}
